import $thousandMask from "@/mixins/thousandMask";
export default {
  name: "profit-or-loses-amount-in-table",
  components: {},
  mixins: [$thousandMask],
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
